// TabContext.js
import React, { createContext, useContext, useState } from "react";

// Create context
const TabContext = createContext();

// Provider
export const TabProvider = ({ children }) => {
  const [active, setActive] = useState("dashboard");
  const [activeMaster, setActiveMaster] = useState(0);
  const [headerDetails, setheaderDetails] = useState({});

  return (
    <TabContext.Provider value={{ active, setActive, activeMaster, setActiveMaster,headerDetails, setheaderDetails }}>
      {children}
    </TabContext.Provider>

  );
};

// Custom hook to use the context
export const useTab = () => useContext(TabContext);
